(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurelia-catalog-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aurelia-catalog')) {
class AureliaCatalog extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.cards = [...this.querySelectorAll('[data-category-card]')].sort((a, b) => Number(a.dataset.catalogOrder) - Number(b.dataset.catalogOrder));
    this.buttons = [...this.querySelectorAll('[data-category]')];
    const signal = this.controller.signal;
    this.addEventListener('click', event => {
      const button = event.target instanceof Element ? event.target.closest('[data-category]') : null;
      if (button && this.contains(button)) {
        const url = new URL(window.location.href);
        url.hash = button.dataset.category;
        this.updateLocation(url);
      } else {
        this.rememberReturn(event);
      }
    }, { signal });
    this.addEventListener('auxclick', event => { if (event.button === 1) this.rememberReturn(event); }, { signal });
    this.querySelector('[data-sort]')?.addEventListener('change', event => {
      const url = new URL(window.location.href);
      if (event.target.value === 'az') url.searchParams.set('sort_by', 'title-ascending');
      else url.searchParams.delete('sort_by');
      this.updateLocation(url);
    }, { signal });
    this.querySelector('[data-search-form]')?.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(window.location.href);
      const query = this.querySelector('[data-search-input]').value.trim();
      url.searchParams.set('view', 'aurelia-catalog');
      if (query) url.searchParams.set('q', query);
      else url.searchParams.delete('q');
      url.searchParams.delete('page');
      this.updateLocation(url);
    }, { signal });
    window.addEventListener('hashchange', () => this.applyFilter(), { signal });
    window.addEventListener('popstate', () => this.applyFilter(), { signal });
    this.applyFilter();
  }
  disconnectedCallback() { this.controller?.abort(); }
  updateLocation(url) {
    if (url.href !== window.location.href) history.pushState(history.state, '', url);
    this.applyFilter();
  }
  normalize(value) {
    return String(value || '').normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }
  rememberReturn(event) {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || !this.contains(link) || !link.closest('[data-category-card]') || event.defaultPrevented) return;
    const source = new URL(window.location.href);
    const target = new URL(link.href, source);
    if (target.origin !== source.origin || !/^\/(?:[a-z]{2}(?:-[a-z0-9]{2,8})?\/)?(?:collections(?:\/all)?|search)\/?$/i.test(source.pathname)) return;
    if (!/^\/(?:[a-z]{2}(?:-[a-z0-9]{2,8})?\/)?(?:products_preview|products\/[^/]+)\/?$/i.test(target.pathname)) return;
    const back = new URL(source.pathname, source.origin);
    ['q', 'sort_by', 'view', 'preview_theme_id'].forEach(key => {
      if (source.searchParams.has(key)) back.searchParams.set(key, source.searchParams.get(key));
    });
    back.hash = source.hash;
    try {
      sessionStorage.setItem('aurelia.catalog.return.v1', JSON.stringify({ path: back.pathname + back.search + back.hash, productPath: target.pathname, previewKey: target.searchParams.get('preview_key') || '' }));
    } catch {}
  }
  applyFilter() {
    const url = new URL(window.location.href);
    let category = url.hash.slice(1).toLowerCase();
    if (!this.buttons.some(button => button.dataset.category === category)) category = 'all';
    const query = this.dataset.searchMode === 'true' ? url.searchParams.get('q') || '' : '';
    const words = this.normalize(query).split(' ').filter(Boolean);
    const categoryTerms = {
      earrings: 'earring earrings 耳環 耳环 耳飾 耳饰',
      necklaces: 'necklace necklaces 項鍊 項鏈 项链',
      bracelets: 'bracelet bracelets 手鍊 手鏈 手链 手環 手环'
    };
    const sortValue = ['az', 'title-ascending'].includes(url.searchParams.get('sort_by')) ? 'az' : 'featured';
    const sort = this.querySelector('[data-sort]');
    if (sort) sort.value = sortValue;
    const input = this.querySelector('[data-search-input]');
    if (input) input.value = query;
    this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
    let count = 0;
    this.cards.forEach(card => {
      const inCategory = category === 'all' || card.dataset.categoryCard === category || category === 'featured' && card.dataset.featured === 'true' || category === 'new' && card.dataset.new === 'true';
      const searchable = this.normalize([card.dataset.title, card.dataset.categoryCard, categoryTerms[card.dataset.categoryCard], card.dataset.searchTerms].join(' '));
      const show = inCategory && words.every(word => searchable.includes(word));
      card.hidden = !show;
      if (show) count++;
    });
    const grid = this.querySelector('[data-grid]');
    const ordered = sortValue === 'az' ? [...this.cards].sort((a, b) => (a.dataset.title || '').localeCompare(b.dataset.title || '')) : this.cards;
    if (grid) ordered.forEach(card => grid.append(card));
    const counter = this.querySelector('[data-count]');
    if (counter) counter.textContent = this.dataset.countLabel.replace('[count]', String(count));
    const empty = this.querySelector('[data-empty]');
    if (empty) empty.hidden = count > 0;
  }
}
customElements.define('aurelia-catalog', AureliaCatalog);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurelia-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aurelia-product-slider')) {
    class AureliaProductSlider extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        queueMicrotask(() => {
          if (signal.aborted || !this.isConnected) return;
          this.track = this.querySelector('[data-slider-track]');
          this.cards = [...this.querySelectorAll('[data-slider-card]')];
          this.previous = this.querySelector('[data-slider-previous]');
          this.next = this.querySelector('[data-slider-next]');
          this.controls = this.querySelector('[data-slider-controls]');
          this.status = this.querySelector('[data-slider-status]');
          if (!this.track || !this.cards.length) return;
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.setAttribute('data-enhanced', '');
          this.previous?.addEventListener('click', () => this.step(-1), { signal });
          this.next?.addEventListener('click', () => this.step(1), { signal });
          this.track.addEventListener('keydown', event => this.onKeydown(event), { signal });
          this.track.addEventListener('scroll', () => {
            if (!this.frame) this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.updateControls();
            });
            window.clearTimeout(this.announceTimer);
            this.announceTimer = window.setTimeout(() => this.updateStatus(), 180);
          }, { passive: true, signal });
          this.addEventListener('shopify:block:select', event => {
            const card = event.target.closest('[data-slider-card]');
            if (card && this.contains(card)) this.reveal(card, 'auto');
          }, { signal });
          this.track.addEventListener('focusin', event => {
            const card = event.target.closest('[data-slider-card]');
            if (card) this.reveal(card, 'auto', true);
          }, { signal });
          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(() => {
              this.updateControls();
              this.updateStatus();
            });
            this.observer.observe(this.track);
            this.cards.forEach(card => this.observer.observe(card));
          } else {
            window.addEventListener('resize', () => {
              this.updateControls();
              this.updateStatus();
            }, { signal });
          }
          this.updateControls();
          this.updateStatus();
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.observer = null;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        window.clearTimeout(this.announceTimer);
        this.removeAttribute('data-enhanced');
      }
      direction() {
        return getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      }
      position() {
        return Math.max(0, Math.min(this.maximum(), this.track.scrollLeft * this.direction()));
      }
      maximum() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }
      scrollToPosition(position, behavior = this.motion.matches ? 'auto' : 'smooth') {
        const target = Math.max(0, Math.min(this.maximum(), position));
        this.track.scrollTo({ left: target * this.direction(), behavior });
      }
      step(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const stride = this.cards[0].getBoundingClientRect().width + gap;
        this.scrollToPosition(this.position() + stride * direction);
      }
      onKeydown(event) {
        if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step((event.key === 'ArrowRight' ? 1 : -1) * this.direction());
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.scrollToPosition(event.key === 'Home' ? 0 : this.maximum());
        }
      }
      reveal(card, behavior, onlyWhenClipped = false) {
        const viewport = this.track.getBoundingClientRect();
        const bounds = card.getBoundingClientRect();
        if (onlyWhenClipped && bounds.left >= viewport.left - 1 && bounds.right <= viewport.right + 1) return;
        const distance = this.direction() === 1 ? bounds.left - viewport.left : viewport.right - bounds.right;
        this.scrollToPosition(this.position() + distance, behavior);
      }
      updateControls() {
        const maximum = this.maximum();
        const position = this.position();
        if (this.previous) this.previous.disabled = position <= 2;
        if (this.next) this.next.disabled = maximum - position <= 2;
        if (this.controls) this.controls.hidden = maximum <= 2;
      }
      updateStatus() {
        if (!this.status) return;
        const viewport = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => {
          const bounds = card.getBoundingClientRect();
          return bounds.right > viewport.left + 2 && bounds.left < viewport.right - 2 ? index + 1 : null;
        }).filter(Boolean);
        if (!visible.length) return;
        const message = (this.dataset.statusTemplate || '')
          .replace('[first]', String(visible[0]))
          .replace('[last]', String(visible[visible.length - 1]))
          .replace('[total]', String(this.cards.length));
        if (this.status.textContent !== message) this.status.textContent = message;
      }
    }
    customElements.define('aurelia-product-slider', AureliaProductSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
